import React, { useState } from "react";
import ProductAssignmentModal from "./ProductAssignmentModal";
import ProductAssignPage from "./ProductAssignPage";
import ProductCodePage from "./ProductCodePage";
import { useMediaQuery } from "react-responsive";
import SideBar from "../../components/SideBar";
import { Components } from "../../assets/Dimensions";
import { ToastContainer, toast } from "react-toastify";
import BackButton from "../../components/Base/BackButton";

const ProductAssignment = () => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 700px)" });

  const [mode, setMode] = useState(null); // 'assign' or 'generate'
  const [nav, setNav] = useState(false);
  const handleSelectMode = (selectedMode) => setMode(selectedMode);

  const style = {
    container: {
      //state e bool değer ekle menü butonuna basıldığında css
      //içinde container a margin eklesin hemde navı açsın

      //marginLeft: isTabletOrMobile ? 0 : Components.SideBarWidth + 15,
      paddingLeft: isTabletOrMobile ? 15 : Components.SideBarWidth + 15,
      // paddingTop: 20,
      // paddingRight: 15,
      // marginBottom: 20,
    },
  };

  return (
    <>
      <ToastContainer />
      {isTabletOrMobile ? (
        <div>
          <span
            style={{ position: "absolute", top: 10, right: 10 }}
            onClick={() => setNav(!nav)}
          >
            menu
          </span>
          {nav && <SideBar />}
        </div>
      ) : (
        <SideBar />
      )}
      <div style={style.container}>
      <BackButton />
        {!mode && <ProductAssignmentModal onSelect={handleSelectMode} />}
        {mode === "assign" && (
          <ProductAssignPage onBack={() => setMode(null)} />
        )}
        {mode === "generate" && (
          <ProductCodePage onBack={() => setMode(null)} />
        )}
      </div>
    </>
  );
};

export default ProductAssignment;
